import { essoApiUrl, cmsApiUrl, cmsSuperAppApiUrl } from '@/constants';

const baseHeader = {
    'Content-Type': 'application/json'
}

const multipartFormHeader = {
    'Content-Type': 'multipart/form-data'
}

const apiConfig = {
    account: {
        login: {
            path: `${essoApiUrl}/auth/login`,
            method: 'POST',
            headers: baseHeader,
            isPublic: true,
        },
        getProfile: {
            path: `${essoApiUrl}/account/profile`,
            method: 'GET',
            headers: baseHeader
        },
        refreshToken: {
            path: `${essoApiUrl}/auth/refresh-token`,
            method: 'POST',
            headers: baseHeader,
            isPublic: true,
        },
        updateProfile: {
            path: `${essoApiUrl}/account/update-profile`,
            method: 'PUT',
            headers: baseHeader
        },
        changePassword: {
            path: `${essoApiUrl}/account/change-password`,
            method: 'PUT',
            headers: baseHeader
        },
        logout: {
            path: `${essoApiUrl}/account/logout`,
            method: 'POST',
            headers: baseHeader
        },
    },
    admin: {
        getList: {
            path: `${cmsApiUrl}/admins`,
            method: 'GET',
            headers: baseHeader,
        },
        getRoleList: {
            path: `${cmsApiUrl}/roles`,
            method: 'GET',
            headers: baseHeader,
        },
        getDetail: {
            path: `${cmsApiUrl}/admins/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            path: `${cmsApiUrl}/admins`,
            method: 'POST',
            headers: baseHeader
        },
        update: {
            path: `${cmsApiUrl}/admins`,
            method: 'PUT',
            headers: baseHeader
        },
        updateStatus: {
            path: `${cmsApiUrl}/admins/update-status`,
            method: 'PUT',
            headers: baseHeader
        },
        assignApp: {
            path: `${cmsApiUrl}/admins/assign-app`,
            method: 'POST',
            headers: baseHeader
        },
        getAppAssigned: {
            path: `${cmsApiUrl}/admins/:id/app-assigned`,
            method: 'GET',
            headers: baseHeader
        },
        getListApp: {
            path: `${cmsApiUrl}/admins/active-app`,
            method: 'GET',
            headers: baseHeader
        },
    },
    clientApp: {
        getList: {
            path: `${cmsApiUrl}/client-apps`,
            method: 'GET',
            headers: baseHeader,
        },
        getDetail: {
            path: `${cmsApiUrl}/client-apps/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            path: `${cmsApiUrl}/client-apps`,
            method: 'POST',
            headers: baseHeader
        },
        update: {
            path: `${cmsApiUrl}/client-apps`,
            method: 'PUT',
            headers: baseHeader
        },
        updateStatus: {
            path: `${cmsApiUrl}/client-apps/update-status`,
            method: 'PUT',
            headers: baseHeader
        },
        renewClientAppId: {
            path: `${cmsApiUrl}/client-apps/:id/renew-caid`,
            method: 'PUT',
            headers: baseHeader
        },
        renewSecretId: {
            path: `${cmsApiUrl}/client-apps/:id/renew-secret-key`,
            method: 'PUT',
            headers: baseHeader
        }
    },
    appConfig:{
        getVietGuyConfig: {
            path: `${cmsApiUrl}/app-config/get-by-key`,
            method: 'GET',
            headers: baseHeader
        },
        updateVietGuyConfig: {
            path: `${cmsApiUrl}/app-config`,
            method: 'PUT',
            headers: baseHeader
        },
    },
    transaction:{
        getSMSTransaction: {
            path: `${cmsApiUrl}/transaction/sms`,
            method: 'GET',
            headers: baseHeader
        },
        exportExcel: {
            path: `${cmsApiUrl}/transaction/sms/export`,
            method: 'GET',
            headers: baseHeader
        }
    },
    superApp:{
        getList: {
            path: `${cmsSuperAppApiUrl}/cms/management`,
            method: 'GET',
            headers: baseHeader,
        },
        getDetail: {
            path: `${cmsSuperAppApiUrl}/cms/management/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            path: `${cmsSuperAppApiUrl}/cms/management`,
            method: 'POST',
            headers: baseHeader,
        },
        updateInfo: {
            path: `${cmsSuperAppApiUrl}/cms/management`,
            method: 'PUT',
            headers: baseHeader,
        },
        updateVersion: {
            path: `${cmsSuperAppApiUrl}/cms/management/version`,
            method: 'PUT',
            headers: baseHeader,
        },
        updateStatus: {
            path: `${cmsSuperAppApiUrl}/cms/management/status`,
            method: 'PUT',
            headers: baseHeader,
        },
        exportExcel: {
            path: `${cmsSuperAppApiUrl}/cms/management/export/excel`,
            method: 'GET',
            headers: baseHeader,
        },
        uploadImage: {
            path: `${cmsSuperAppApiUrl}/cms/management/image`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        uploadBundle: {
            path: `${cmsSuperAppApiUrl}/cms/management/file`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        generateToken: {
            path: `${cmsSuperAppApiUrl}/cms/management/generated-token`,
            method: 'PUT',
            headers: baseHeader,
        },
        updatePriority: {
            path: `${cmsSuperAppApiUrl}/cms/management/update-priority`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    media: {
        image: {
            path: `${cmsApiUrl}/departments`,
            method: 'GET',
            headers: baseHeader,
        },
    },
}

export default apiConfig;